import { FormBase } from 'core/components';

export default class EditDateForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'date',
					label: '',
				},
			],
		};
	}
}
